import getOr from "lodash/fp/getOr";
import find from "lodash/find";

const newPlus = require("../assets/images/new-plus.svg");
const newSub = require("../assets/images/new-sub.svg");

export class Regulation {
  constructor(endDate, rank, startDate, summary, textLink, title, webLink, comments, sectionName, ntmIndex, index) {
    this.endDate = endDate;
    this.rank = rank;
    this.startDate = startDate;
    this.summary = summary;
    this.textLink = textLink;
    this.title = title;
    this.webLink = webLink;
    this.comments = comments;
    this.sectionName = sectionName;
    this.ntmIndex = ntmIndex;
    this.index = index;
  }

  genHtml() {
    const title = this.title ? `<p><b>Legislation title</b>: ${this.title}</p>` : "";
    const summary = this.summary ? `<p><b>Legislation summary</b>: ${this.summary}</p>` : "";
    const commends = this.comments.length ? `<p><b>Legislation comments</b>: ${this.comments.join(" ")}</p>` : "";
    const document = this.textLink ? `<p><b>Document</b>: <a target="_blank" href="${this.textLink}">Click here</a></p>` : "";
    const website = this.textLink ? `<p><b>Website</b>: <a target="_blank" href="${this.webLink}">Click here</a></p>` : "";
    let startDate = window.moment(this.startDate);
    startDate = startDate.isValid() ? startDate.format("yyyy-MM-DD") : "";
    let endDate = window.moment(this.endDate);
    endDate = endDate.isValid() ? endDate.format("yyyy-MM-DD") : "";
    let validity = (startDate ? "from " + startDate + " " : "") + (endDate ? "to " + endDate : "");
    validity = validity ? `<p><b>Validity</b>: ${validity}</p>` : "";
    return `
      <div class="item">
        <div class="head d-flex collapsed" data-toggle="collapse" data-target="#${this.sectionName}-${this.ntmIndex}-${this.index}" aria-expanded="false" aria-controls="${this.sectionName}-${this.ntmIndex}-${this.index}" >
          <div class="title mr-auto">${this.title}</div>
          <div class="arrow">
            <img class="arrow-open" src="${newPlus}" alt="arrow down" />
            <img class="arrow-close" src="${newSub}" alt="arrow down" />
          </div>
        </div>
        <div class="collapse data" id="${this.sectionName}-${this.ntmIndex}-${this.index}">
          <div class="content">
            ${title}
            ${commends}
            ${summary}
            ${validity}
            ${document}
            ${website}
          </div>
        </div>
      </div>
    `
  }

  static fromApiObject(input, referencs, sectionName, ntmIndex, index) {
    if (typeof (input) === "object" && input !== null) {
      const rank = getOr("", "rank")(input);
      const comments = getOr([], "comments")(input);
      const obj = referencs ? find(referencs, { rank: rank }) : input;
      const endDate = getOr("", "endDate")(obj);
      const startDate = getOr("", "startDate")(obj);
      const summary = getOr("", "summary")(obj);
      const textLink = getOr("", "textLink")(obj);
      const title = getOr("", "title")(obj);
      const webLink = getOr("", "webLink")(obj);
      return new Regulation(endDate, rank, startDate, summary, textLink, title, webLink, comments, sectionName, ntmIndex, index);
    }
    return new Regulation();
  }

  static fromApiArray(input, referencs, sectionName, ntmIndex) {
    if (Array.isArray(input)) {
      return input.map((item, index) => Regulation.fromApiObject(item, referencs, sectionName, ntmIndex, index));
    }
    if (typeof (input) === "object" && input !== null) {
      return [Regulation.fromApiObject(input, referencs, sectionName, ntmIndex, 0)];
    }
    return [];
  }
}